import TrainingDetails from 'Components/Trainings/TrainingAdvertisementDetails';
import EducationLayout from 'Components/Layout/EducationLayout';
import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;
const SingleTrainingAdvertisement = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <EducationLayout>
      <ContentContainer>
        <TrainingDetails trainingId={id} educationPanel />
      </ContentContainer>
    </EducationLayout>
  );
};

export default SingleTrainingAdvertisement;
